/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { ScrollSource } from '@components/editor-page/editor-page-content'
import type { Action } from 'redux'

export enum EditorConfigActionType {
  SET_EDITOR_VIEW_MODE = 'editor/view-mode/set',
  SET_SYNC_SCROLL = 'editor/syncScroll/set',
  SET_LIGATURES = 'editor/preferences/setLigatures',
  SET_LINE_WRAPPING = 'editor/preferences/setLineWrapping',
  SET_SMART_PASTE = 'editor/preferences/setSmartPaste',
  SET_SPELL_CHECK = 'editor/preferences/setSpellCheck',
  SET_SCROLL_SOURCE = 'editor/preferences/setScrollSource',
  SET_EDITOR_DOC_CHANGE = 'editor/editor/docChange',
}

export interface EditorConfig {
  syncScroll: boolean
  ligatures: boolean
  smartPaste: boolean
  spellCheck: boolean
  lineWrapping: boolean
  scrollSource: ScrollSource
  editorDocChange: boolean
}

export type EditorConfigActions =
  | SetEditorSyncScrollAction
  | SetEditorLigaturesAction
  | SetEditorSmartPasteAction
  | SetEditorLineWrappingAction
  | SetSpellCheckAction
  | SetScrollSourceAction
  | SetEditorDocChangeAction

export interface SetEditorLineWrappingAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_LINE_WRAPPING
  lineWrapping: boolean
}

export interface SetEditorSyncScrollAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_SYNC_SCROLL
  syncScroll: boolean
}

export interface SetScrollSourceAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_SCROLL_SOURCE
  scrollSource: ScrollSource
}

export interface SetEditorLigaturesAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_LIGATURES
  ligatures: boolean
}

export interface SetEditorSmartPasteAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_SMART_PASTE
  smartPaste: boolean
}

export interface SetSpellCheckAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_SPELL_CHECK
  spellCheck: boolean
}

export interface SetEditorDocChangeAction extends Action<EditorConfigActionType> {
  type: EditorConfigActionType.SET_EDITOR_DOC_CHANGE
  editorDocChange: boolean
}
